import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Privacy() {
    return (
        <main className="min-h-screen bg-white">
            <Navbar />
            <div className="pt-32 pb-24 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-primary mb-8 text-center">Privacy Policy</h1>

                <div className="prose prose-blue max-w-none text-text-muted space-y-8">
                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">1. Information We Collect</h2>
                        <p>
                            We collect information that you provide directly to us when you register for an account, such as your name, email address, and professional information. We also collect data from tools you integrate with Ianos (e.g., Jira, ServiceNow) to provide our services.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">2. How We Use Your Information</h2>
                        <p>
                            We use information we collect to:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Provide, maintain, and improve our services;</li>
                            <li>Process transactions and send related information;</li>
                            <li>Send you technical notices, updates, and support messages;</li>
                            <li>Respond to your comments and questions.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">3. Data Integration</h2>
                        <p>
                            When you connect third-party tools (like Jira or ServiceNow), Ianos only accesses metadata required to enforce your team's validation rules. We do not store the full content of your tickets unless explicitly required for the functionality of the service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">4. Security</h2>
                        <p>
                            We take reasonable measures to help protect information about you from loss, theft, misuse, and unauthorized access, disclosure, alteration, and destruction.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">5. Contact Us</h2>
                        <p>
                            If you have any questions about this Privacy Policy, please contact us at:
                        </p>
                        <p className="mt-4">
                            <strong>Email:</strong> nicola.sarli@ianos.io<br />
                            <strong>LinkedIn:</strong> <a href="https://www.linkedin.com/company/ianosinc/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">Ianos AI</a>
                        </p>
                    </section>
                </div>
            </div>
            <Footer />
        </main>
    );
}
